module.exports = __webpack_public_path__ + "static/media/dinner.e27b7230.svg";